import AppTypography from '../../typography/Typography';

/**
 * Renders the informational body content of a DynamicPopup modal.
 * Form fields are rendered separately by PopupFields.
 *
 * @param {Object} props
 * @param {string} [props.note]
 * @param {string} [props.description]
 * @param {boolean} [props.showSelectedCount]
 * @param {number} [props.count]
 * @param {string} [props.itemLabel]
 * @param {string|null} [props.bodyText]
 * @param {string|null} [props.deleteError]
 */
export default function PopupBody({
  note,
  description,
  showSelectedCount,
  count,
  itemLabel,
  bodyText,
  deleteError,
}) {
  return (
    <>
      {note && (
        <AppTypography variant="body" color="secondary" className="dynamic-popup__note">
          {note}
        </AppTypography>
      )}
      {description && (
        <AppTypography variant="body" className="dynamic-popup__description">
          {description}
        </AppTypography>
      )}
      {showSelectedCount && count > 0 && (
        <AppTypography variant="body" className="dynamic-popup__selected-count">
          Changing status for <strong>{count}</strong> selected {itemLabel}.
        </AppTypography>
      )}
      {bodyText && (
        <AppTypography variant="body">
          {bodyText}
        </AppTypography>
      )}
      {deleteError && (
        <AppTypography variant="caption" color="danger" className="dynamic-popup__error">
          {deleteError}
        </AppTypography>
      )}
    </>
  );
}
